export enum DATA_QA {
  ROOT = 'launch-campaign',
  BANNER = 'launch-campaign__banner',
  BANNER_ICON = 'launch-campaign__banner-icon',
  BANNER_TITLE = 'launch-campaign__banner-title',
  CONTENT = 'launch-campaign__content',
  DIVIDER = 'launch-campaign__divider',
  BACK_BUTTON = 'launch-campaign__back-button',
  CONTINUE_BUTTON = 'launch-campaign__continue-button',
}
